<template>
  <p class="font-neutron italic text-2xl text-tertiary-foreground max-w-[780px] font-normal tracking-wide">
    <slot />
  </p>
</template>
